import { z } from "zod";

// Security settings page (opt-in TOTP 2FA) — GET/POST /v2/auth/2fa/*.

export const TwoFactorStatusSchema = z.object({
  enabled: z.boolean(),
});
export type TwoFactorStatus = z.infer<typeof TwoFactorStatusSchema>;

export const TwoFactorEnrollResponseSchema = z.object({
  secret: z.string(),
  otpauth_uri: z.string(),
});
export type TwoFactorEnrollResponse = z.infer<typeof TwoFactorEnrollResponseSchema>;

export const TwoFactorCodeRequestSchema = z.object({
  code: z.string().min(1, "Enter the 6-digit code"),
});
export type TwoFactorCodeRequest = z.infer<typeof TwoFactorCodeRequestSchema>;
